jQuery(document).ready(function($){

  $('.testimonials').each(function(){

    $(this).slick();

  });

});
